import { useQuery } from '@tanstack/react-query';
import { PersonaService } from '../PersonaService';

// Persona queries
export const usePersonaInfo = (id) =>
  useQuery({
    queryKey: ['persona', 'info', id],
    queryFn: () => PersonaService.getPersonaInfo(id),
    enabled: !!id,
  });

export const useAllPersonas = (page, pageSize) =>
  useQuery({
    queryKey: ['personas', 'all', page, pageSize],
    queryFn: () => PersonaService.listAllPersonas(page, pageSize),
  });

// Reference Data queries
export const usePersonaMasterData = () =>
  useQuery({
    queryKey: ['persona', 'master-data'],
    queryFn: () => PersonaService.getPersonaMasterData(),
  });
